import { useEffect }  from 'react'
import { Routes, Route, Navigate } from 'react-router-dom'
import { AnimatePresence } from 'framer-motion'
import HomeScreen from './screens/HomeScreen/HomeScreen'
import CardOfTheDayScreen from './screens/CardOfTheDayScreen/CardOfTheDayScreen'
import AstroPrognosisScreen from './screens/AstroPrognosisScreen/AstroPrognosisScreen'
import ZodiacPrognosisScreen from './screens/ZodiacPrognosisScreen/ZodiacPrognosisScreen'
import LuckyCardScreen from './screens/LuckyCardScreen/LuckyCardScreen'
import RegisterScreen from './screens/RegisterScreen/RegisterScreen'
import { UI_STYLES, AppScreen } from './components/ui'
import LoginScreen from './screens/LoginScreen/LoginScreen'
import ForgotPasswordScreen from './screens/ForgotPasswordScreen/ForgotPasswordScreen'
import ChatScreen from './screens/ChatScreen/ChatScreen'
import SubscriptionScreen from './screens/SubscriptionScreen/SubscriptionScreen'
import { AuthProvider } from './contexts/AuthContext'
import { ProtectedRoute } from './components/ProtectedRoute'
import { PublicRoute } from './components/PublicRoute'
import { SubscriptionProvider } from './contexts/SubscriptionContext'
import { useDeviceInfo } from './hooks/useDeviceInfo'
import { logDeviceInfo } from './utils/deviceLogger'

const basePath = '/app';

const AppRoute = {
  Home: basePath+"/",
  CardOfTheDay: basePath + '/card-of-day',
  AstroPrognosis: basePath + '/astro',
  ZodiacPrognosis: basePath + '/zodiac',
  LuckyCard: basePath + '/lucky-card',
  Register: basePath + '/register',
  Login: basePath + '/login',
  ForgotPassword: basePath + '/forgot-password',
  Chat: basePath + '/chat',
  Subscription: basePath + '/subscription',
} as const;

function App() {
  const deviceInfo = useDeviceInfo();
  useEffect(() => {
    logDeviceInfo(deviceInfo);
  }, [deviceInfo]);

  return (
    <>
    <AuthProvider>
      <SubscriptionProvider>
        <AnimatePresence mode="wait">
          <AppScreen className={UI_STYLES.backgroundGradientTailwind}>
              <Routes>
                <Route path={AppRoute.Login} element={<PublicRoute><LoginScreen /></PublicRoute>} />
                <Route path={AppRoute.Register} element={<PublicRoute><RegisterScreen /></PublicRoute>} />
                <Route path={AppRoute.ForgotPassword} element={<PublicRoute><ForgotPasswordScreen /></PublicRoute>} />
                
                <Route path={AppRoute.Home} element={<ProtectedRoute><HomeScreen /></ProtectedRoute>} />
                <Route path={AppRoute.CardOfTheDay} element={<ProtectedRoute><CardOfTheDayScreen /></ProtectedRoute>} />
                <Route path={AppRoute.AstroPrognosis} element={<ProtectedRoute><AstroPrognosisScreen /></ProtectedRoute>} />
                <Route path={AppRoute.ZodiacPrognosis} element={<ProtectedRoute><ZodiacPrognosisScreen /></ProtectedRoute>} />
                <Route path={AppRoute.LuckyCard} element={<ProtectedRoute><LuckyCardScreen /></ProtectedRoute>} />
                <Route path={AppRoute.Chat} element={<ProtectedRoute><ChatScreen /></ProtectedRoute>} />
                <Route path={AppRoute.Subscription} element={<ProtectedRoute><SubscriptionScreen /></ProtectedRoute>} />

                <Route path="*" element={<Navigate to={AppRoute.Home} replace />} />
              </Routes>

          </AppScreen>
          </AnimatePresence>
        </SubscriptionProvider>
      </AuthProvider>
      </>
  )
}



export { App, AppRoute };
